import * as THREE from "three";
import { WallType } from "../types/floorplannerTypes";
import type { FloorplannerStore } from "../store/floorplannerStore";
import { jointDetector } from "./JointDetector";
import {
  getMultiJointEndpointTrimPairForJoint,
  getMultiJointEndpointTrimPointForJoint,
} from "./jointEndpointTrimGeometry";

let _floorplannerStore: FloorplannerStore | null = null;
const getFloorplannerStore = (): FloorplannerStore => {
  if (!_floorplannerStore) {
    const globalStore = (globalThis as typeof globalThis & { __boniFloorplannerStore?: FloorplannerStore }).__boniFloorplannerStore;
    if (globalStore) {
      _floorplannerStore = globalStore;
    } else {
      throw new Error("FloorplannerStore not yet initialized - multiJointEndpointTrim called too early");
    }
  }
  return _floorplannerStore;
};

export const getMultiJointEndpointTrimPair = (
  wall: WallType,
  endpoint: "start" | "end",
): { left: THREE.Vector2; right: THREE.Vector2 } | null => {
  const joint = jointDetector.getJointAtEndpoint(wall.id, endpoint);
  if (!joint || joint.connectedWalls.length < 3) {
    return null;
  }

  return getMultiJointEndpointTrimPairForJoint(joint, wall, endpoint, () => getFloorplannerStore().wallWidth);
};

export const getMultiJointEndpointTrimPoint = (
  wall: WallType,
  endpoint: "start" | "end",
  side: "left" | "right",
  lineStart: THREE.Vector2,
  lineEnd: THREE.Vector2,
): THREE.Vector2 | null => {
  const joint = jointDetector.getJointAtEndpoint(wall.id, endpoint);
  if (!joint || joint.connectedWalls.length < 3) {
    return null;
  }

  return getMultiJointEndpointTrimPointForJoint(
    joint,
    wall,
    endpoint,
    side,
    lineStart,
    lineEnd,
    () => getFloorplannerStore().wallWidth,
  );
};
